import { Col, Nav, NavItem, Row } from 'react-bootstrap';
import { capitalize, keys } from 'lodash';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

export const HEARING_LIST_TABS = {
  LIST: 'list',
};

const HearingListTabs = ({ activeTab, changeTab }) => (
  <Row>
    <Col md={8} mdPush={2}>
      <Nav className="hearing-list__tabs" bsStyle="tabs" activeKey={activeTab}>
        {keys(HEARING_LIST_TABS).map(key => {
          const value = HEARING_LIST_TABS[key];
          return (
            <NavItem key={key} eventKey={value} title={capitalize(value)}
                     onClick={() => changeTab(value)} role="tab">
              <FormattedMessage id={value} />
            </NavItem>
          );
        })}
      </Nav>
    </Col>
  </Row>
);

HearingListTabs.propTypes = {
  activeTab: PropTypes.string,
  changeTab: PropTypes.func,
};

export default HearingListTabs;